import partExhibitors from '@constants/values/partExhibitors'

export default function offerDealerOrPrivate(offerData) {
    if (!offerData) return {}

    return {
        dealer: Boolean(offerData.dealer || offerData.exhibitor === partExhibitors[0]),
        priv: Boolean(offerData.private || offerData.exhibitor === partExhibitors[1]),
    }
}